import Campaigns from '../Campaigns'

export const homeRoute = '/'

export const ROUTE_TITLES = {
  [homeRoute]: 'Campaign'
}

export const routeLinks = () => {
  return [
    {
      linkRoute: homeRoute,
      content: Campaigns,
      label: ROUTE_TITLES[homeRoute]
    }
  ]
}
